import { AutoMap } from '@automapper/classes';

export class PointageJournalierEntity {
    Id?: number;
    @AutoMap()
    DepartDomicile?: string;
    @AutoMap()
    DebutJournee!: string;
    @AutoMap()
    FinJournee!: string;
    @AutoMap()
    ArriveeDomicile?: string;
    PointagePauseIds?: number[];
}
